import { Extension, Node } from "@tiptap/core";

const BLOCKS = ["paragraph", "heading", "listItem"];

// Retrait et interligne au niveau des paragraphes
export const BlockStyle = Extension.create({
  name: "blockStyle",
  addGlobalAttributes() {
    return [{
      types: BLOCKS,
      attributes: {
        indent: {
          default: 0,
          parseHTML: (el) => Math.round((parseFloat(el.style.marginLeft) || 0) / 2),
          renderHTML: (a) => (a.indent ? { style: `margin-left: ${a.indent * 2}em` } : {}),
        },
        lineHeight: {
          default: null,
          parseHTML: (el) => el.style.lineHeight || null,
          renderHTML: (a) => (a.lineHeight ? { style: `line-height: ${a.lineHeight}` } : {}),
        },
      },
    }];
  },
  addCommands() {
    const each = (fn) => () => ({ state, tr, dispatch }) => {
      state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos) => {
        if (BLOCKS.includes(node.type.name)) tr.setNodeMarkup(pos, undefined, { ...node.attrs, ...fn(node.attrs) });
      });
      if (dispatch) dispatch(tr);
      return true;
    };
    return {
      indent: each((a) => ({ indent: Math.min((a.indent || 0) + 1, 8) })),
      outdent: each((a) => ({ indent: Math.max((a.indent || 0) - 1, 0) })),
      setBlockLineHeight: (lh) => each(() => ({ lineHeight: lh }))(),
    };
  },
});

export const PageBreak = Node.create({
  name: "pageBreak",
  group: "block",
  atom: true,
  parseHTML: () => [{ tag: "div[data-page-break]" }],
  renderHTML: () => ["div", { "data-page-break": "true", class: "page-break" }],
  addCommands() {
    return { setPageBreak: () => ({ commands }) => commands.insertContent([{ type: this.name }, { type: "paragraph" }]) };
  },
});
